export default function initMobileLanguageDropdown() {
  const toggles = document.querySelectorAll(".js-language-selector");

  const MOBILE_BREAKPOINT = 992;

  const isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

  function openMenu(toggle) {
    toggle.setAttribute("aria-expanded", "true");
    toggle
      .closest(".language-selector__nav")
      .querySelector(".language-selector__menu")
      .classList.add("subnav-list--open");
  }

  function closeMenu(toggle) {
    toggle.setAttribute("aria-expanded", "false");
    toggle
      .closest(".language-selector__nav")
      .querySelector(".language-selector__menu")
      .classList.remove("subnav-list--open");
  }

  function toggleMenu(e) {
    if (!isMobile()) return; // Only allow toggle on mobile
    e.preventDefault();
    let toggle = e.target.closest(".js-language-selector");
    toggle.getAttribute("aria-expanded") === "true"
      ? closeMenu(toggle)
      : openMenu(toggle);
  }

  toggles?.forEach(item => item.addEventListener("click", toggleMenu));

  // Optional: close menu on resize to desktop
  window.addEventListener("resize", () => {
    if (!isMobile()) {
      toggles.forEach(toggle => closeMenu(toggle));
    }
  });
}
